module.exports = __webpack_public_path__ + "static/media/home.9de021fb.svg";